<template>
  <div data-test="in-this-way">
    <label class="text-sm font-semibold test-gray-700">In this way</label>
    <div class="flex flex-col">
      <div
        v-for="(option, idx) in options"
        :key="idx"
      >
        <m-radio-item
          :id="`option-${idx}`"
          :option="option"
          :modelValue="value"
          @change="$emit('input', $event)"
        />
        <slot :selected="value === option.value()"></slot>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'in-this-way',
  props: {
    selections: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      required: true,
    },
  },
  computed: {
    options() {
      return this.selections.map(selection => ({
        extra: selection.extra,
        value: () => selection.label,
      }));
    },
  },
};
</script>
